import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { MarketingNav } from "./MarketingNav";
import { PRODUCT_LINKS, linkId } from "./navigation";
import { useDocumentMeta } from "./seo";
import "./marketing.css";

export { MarketingNav } from "./MarketingNav";

const FOOTER = [
  ["Platform", PRODUCT_LINKS],
  ["Company", [["About", "/about"], ["Use cases", "/customers"], ["Fund managers", "/fund-managers"], ["Careers", "/careers"], ["Contact", "/contact"]]],
  ["Resources", [["Product tour", "/tour"], ["Option calculator", "/tools/option-calculator"], ["Documentation", "/docs"], ["Guides", "/guides"], ["Security", "/security"], ["Status", "/status"]]],
];

export const MarketingFooter = () => (
  <footer className="mk-footer" data-testid="marketing-footer">
    <div className="mk-container">
      <div className="mk-footer-top">
        <div><Link to="/" data-testid="footer-home"><Logo light testId="marketing-footer-logo" /></Link><p>The founder-investor operating system.<br />Progress, shared with confidence.</p></div>
        {FOOTER.map(([label, links]) => <div key={label}><h2>{label}</h2><ul>{links.map(([name, href]) => <li key={href}><Link to={href} data-testid={`footer-${linkId(href)}`}>{name}</Link></li>)}</ul></div>)}
      </div>
      <div className="mk-footer-statement" aria-hidden="true">Better together<span>.</span></div>
      <div className="mk-footer-bottom"><span data-testid="footer-copyright">© {new Date().getFullYear()} TenX. All rights reserved.</span><div><Link to="/privacy" data-testid="footer-privacy">Privacy</Link><Link to="/terms" data-testid="footer-terms">Terms</Link><Link to="/contact" data-testid="footer-talk">Let's talk <ArrowUpRight size={14} /></Link></div></div>
    </div>
  </footer>
);

export const MarketingLayout = ({ children, className = "", meta }) => {
  const { pathname, hash } = useLocation();
  useDocumentMeta(meta);
  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ block: "start" }), 80);
      return () => clearTimeout(timer);
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return <div className={`tenx-marketing ${className}`} data-testid="marketing-layout">
    <a href="#marketing-main" className="mk-skip" data-testid="marketing-skip-link">Skip to content</a>
    <MarketingNav />
    <main id="marketing-main" tabIndex={-1}>{children}</main>
    <MarketingFooter />
  </div>;
};